// import React from 'react';

import clsx from "clsx"
import SvgIcon from "../CustomeComponents/SvgIcon"

const Section = ({ title, icon, children, className,...others }) => {
    return (
        <div className={clsx('section', className)}>
            <div className="section-header">
                <div className="section-icon">
                    <SvgIcon icon={icon} />
                </div>
                <div className="section-title">{title}</div>
            </div>
            
            <div className="section-content">
                {children}
            </div>
            
            {/* {
                others.compRender && others.compRender === "TamztitTaba" ? 
                    <div className="section-content">
                        {children}
                    </div>
                    :
                    <div className="section-content" style={{ textAlign: "center", margin: "auto" }}>
                        {children}
                    </div>
            } */}

        </div>
    )
}

export default Section